import { Component } from "@angular/core";

@Component({
  selector: "app-replacement-claim-schedule",
  templateUrl: "./replacement-claim-schedule.component.html",
  styleUrls: ["./replacement-claim-schedule.component.less"],
})
export class ReplacementClaimScheduleComponent {}
